import type { CompanySettingModel, CompanySettingName } from '../redux/api/web-api'

export const DEFAULT_BILLING_COUNTRY = 'SE'

export type OrganisationSettingsValues = {
    communicationLanguage: string
    billingCountry: string
}

export const getCompanySettingValue = (
    settings: CompanySettingModel[] | undefined,
    settingName: CompanySettingName
): string | null => {
    const setting = settings?.find((item) => item.name?.toLowerCase() === settingName.toLowerCase())

    return setting?.value?.trim() || null
}

export const mapOrganisationSettingsToCompanySettings = ({
    communicationLanguage,
    billingCountry,
}: OrganisationSettingsValues): CompanySettingModel[] => [
    {
        name: 'Language',
        value: communicationLanguage,
    },
    {
        name: 'BillingCountry',
        value: billingCountry,
    },
]
